import { Skeleton } from '@/components/atoms/Skeleton';

import { theme } from '@/styles/theme';

export default function AccordionDuvidasFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: `${theme.spacing[5]}px ${theme.spacing[4]}px`,
        gap: theme.spacing[5],
      }}
    >
      <Skeleton style={{ width: '65vw', height: 32 }} />
      <Skeleton style={{ height: 341, marginTop: theme.spacing[5] }} />
    </div>
  );
}
